module.exports = __webpack_public_path__ + "assets/img/xywx.9f8ed8fb.png";